// Note: types exposed from `index.d.ts`.
export { eventsToAcorn } from './lib/index.js';